import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Autocomplete, { highlightSubstring } from '@afosto/app-components-react/Autocomplete';
import useIntl from '@afosto/utils-react/intl/useIntl';

const ScopesAutocomplete = ({ name, label, options, loading, ...props }) => {
  const intl = useIntl();
  /**
   * Render the scope options in the auto complete dropdown.
   * @param {object} option
   * @param {string} inputValue
   * @returns {Component}
   */
  const renderScopeOptions = (option, { inputValue = '' } = {}) => {
    let optionLabel = option;

    if (typeof option === 'object') {
      // eslint-disable-next-line prefer-destructuring
      optionLabel = option.label;
    }

    return (
      <ListItemText
        primary={highlightSubstring(optionLabel, inputValue)}
        secondary={highlightSubstring(option.description, inputValue)}
      />
    );
  };

  const renderScopeTags = (values, getTagProps, ChipProps) => (
    <>
      {values.map((value, index) => (
        <Tooltip
          key={value.label}
          title={intl.formatMessage({
            id: `scopeDescriptions.${value.label}`,
            defaultMessage: value.description,
            description: `description for the scope ${value.label}`,
          })}
          placement="bottom"
        >
          <Chip
            label={value.label
              .split(':')
              .map(part =>
                intl.formatMessage({
                  id: `scopeParts.${part}`,
                  defaultMessage: part,
                  description: `label of the scope part ${part}`,
                }),
              )
              .join(':')}
            {...getTagProps({ index })}
            {...ChipProps}
          />
        </Tooltip>
      ))}
    </>
  );

  return (
    <Autocomplete
      {...props}
      name="scopes"
      disablePortal
      disableCloseOnSelect
      clearInputValueOnSelect={false}
      label={label}
      options={options}
      filterSelectedOptions={false}
      loading={loading}
      renderOption={renderScopeOptions}
      renderTags={renderScopeTags}
      multiple
    />
  );
};

ScopesAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.array,
  loading: PropTypes.bool,
};

ScopesAutocomplete.defaultProps = {
  label: '',
  options: [],
  loading: false,
};

export default ScopesAutocomplete;
